import React from 'react';
import './App.css';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>El Madrid te roba, siempre</h1>
        <h2>
          ¿Cuántas veces te ha robado el Madrid?
        </h2>
        <p>Este es un proyecto comunitario para demostrar (matemáticamente) que el Madrid atraca mucho más que el resto de equipos de la liga.</p>
      </header>
    </div>
  );
}

export default App;
